import { gsap } from "gsap";
import { GenericHandler } from './GenericPageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { imagesLoaded } from 'imagesloaded';
import { Utils } from "./Utils";

export class HomePageHandler extends GenericHandler {
	constructor(id) {
		super(id);
		this.$imgOne = jQuery('.hero__right .large-image')
		this.$imgTwo = jQuery('.hero__right .small-image:eq(0)')
		this.$imgThree = jQuery('.hero__right .small-image:eq(1)')
		this.$fwImage = jQuery('.full-width-image')
		this.$popup = jQuery('.popup-section')
		this.$aboutUsImage = jQuery('.about-us__image')
	
	}

	ajax() {

	}

	events() {
		
	}

	transitions() {
		var _this = this;
		jQuery(".hero__right").imagesLoaded(() => {
			gsap.timeline()
				.fromTo(this.$imgOne, {autoAlpha: 0, x: -50}, {autoAlpha: 1, x: 0, duration: 0.8, ease: "power2.inout"})
				.fromTo(this.$imgTwo, {autoAlpha: 0, x: 50}, {autoAlpha: 1, x: 0, duration: 0.8, ease: "power2.inout"}, "-=0.4")
				.fromTo(this.$imgThree, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.inout"}, "-=0.4")
		})
		
		
		gsap.fromTo('.hero__left', {y: 50}, {autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.inout", onComplete: () => {
			_this.$fwImage.imagesLoaded(() => {
				gsap
					.to(this.$fwImage, {autoAlpha: 1,  duration: 0.8, ease: "power2.inout"})
			})
		}})
		let mm = gsap.matchMedia();
		mm.add("(max-width: 767px)", () => {
			// gsap.set('.popup-section img', {autoAlpha: 0})
			_this.$aboutUsImage.imagesLoaded(() => {
				gsap
					.to(this.$aboutUsImage, {autoAlpha: 1,  duration: 0.8, ease: "power2.inout"})
			})
			ScrollTrigger.create({
				trigger: ".about-us-section",
				start: "top 30%",
				onLeaveBack: self => self.disable(),
				onEnter: () => {
					gsap.fromTo('.about-us__text', {x: 50, autoAlpha: 0}, {x: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
				}
			})

			// ScrollTrigger.create({
			// 	trigger: ".popup-section",
			// 	start: "top bottom",
			// 	onLeaveBack: self => self.disable(),
			// 	onEnter: () => {
			// 		gsap.fromTo('.popup-section img', {autoAlpha: 0}, {autoAlpha: 1})
			// 	}
			// })
		})

		mm.add("(min-width: 768px)", () => {
			// gsap.set('.popup-section img', {autoAlpha: 0})
			ScrollTrigger.create({
				trigger: ".about-us-section",
				start: "top 30%",
				onLeaveBack: self => self.disable(),
				onEnter: () => {
					gsap.fromTo(this.$aboutUsImage, {x: -50}, {x: 0, autoAlpha: 1,  duration: 0.8, ease: "power2.inout"})
					gsap.fromTo('.about-us__text', {x: 50, autoAlpha: 0}, {x: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
				}
			})
			// ScrollTrigger.create({
			// 	trigger: ".popup-section",
			// 	start: "top bottom",
			// 	onLeaveBack: self => self.disable(),
			// 	onEnter: () => {
			// 		gsap.fromTo('.popup-section img', {autoAlpha: 0}, {autoAlpha: 1})
			// 	}
			// })
		})

		ScrollTrigger.batch(".instagram__post", {
			onEnter: (elements, triggers) => {
			  gsap.to(elements, {autoAlpha: 1, stagger: 0.25});
			}
		  });

		  ScrollTrigger.batch(".review", {
			onEnter: (elements, triggers) => {
			  gsap.fromTo(elements, {y: 50}, {y: 0, autoAlpha: 1, stagger: 0.25});
			}
		  });
	}

	init() {
		

	}

	destroy() {

	}
}
